import axios from 'axios';
import AbstractDataService from './abstract.data.service';
import { settingFiles } from './settings.const';
import demo from '../demo/data';

async function settings() {
    let result = {};

    for (let item of settingFiles) {
        let name = item.split('.')[0];
        result[name] = await axios.get(`/demo/setting/${item}`)
            .then((result) => {
                return result.data;
            });
    }

    return result;
}

function load(year, month) {
    return axios.get(`/demo/data/${(new Date().getFullYear() - year)}-${month.toString().padStart(2, '0')}.json`)
        .then((result) => {
            return result.data;
        });
}

function wishlist() {
    return axios.get(`/demo/wishlist.json`)
        .then((result) => {
            return result.data;
        });
}

class DemoDataService extends AbstractDataService {
    constructor() {
        super();
        this.init();
    }

    refreshWallets() {
        this.wallets = demo.periods.map((period) => {
            let wallet = {
                id: period.id,
                year: new Date().getFullYear() - period.year,
                month: period.month
            }

            this.walletWrappering(wallet);

            return wallet;
        });
    }

    loadSettings() {
        return settings();
    }

    saveSetting() {
        const message = 'Action is not allowed in demo version';
        console.log(message);

        return Promise.reject({ message });
    }


    loadWishlist() {
        return wishlist();
    }

    saveWishlist() {
        const message = 'Action is not allowed in demo version';
        console.log(message);

        return Promise.reject({ message });
    }

    walletMethods() {
        let app = this;

        return {
            save() {
                const message = 'Action is not allowed in demo version';
                console.log(message);

                return Promise.reject({ message });
            },
            remove() {
                const message = 'Changes will lose after refresh page';
                console.log(message);

                app.removeWallet(this);
                return Promise.resolve();
            },
            reset() {
                let { year, month } = this;
                return load(year, month).then((data) => {
                    this.data = data;
                    return this;
                });
            }
        }
    }

    async getWallet(year, month) {
        let wallet = await super.getWallet(year, month);

        if (!wallet.data) {
            return load(year, month).then((data) => {
                wallet.data = data;
                return wallet;
            });
        } else {
            return Promise.resolve(wallet);
        }
    }
}

export default DemoDataService;